import { createSelector } from '@reduxjs/toolkit'
import { RootState } from '../reducers'

export const getListRoles = (state: RootState) => state.roles.listRolesData
export const getRolesToUserId = (state: RootState) => state.roles.rolesUserID
